import { useTranslation } from "react-i18next";

const LastName = ({ loading, formik, getInputClasses }) => {
  const { t } = useTranslation();

  return (
    <div className="fv-row mb-10">
      <label className='form-label fs-6 fw-bolder text-dark'>{t("auth:create_account.input.last_name.label")}</label>
      <input
        disabled={loading}
        placeholder={t("auth:create_account.input.last_name.placeholder")}
        type="text"
        className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
          "last_name"
        )}`}
        name="last_name"
        {...formik.getFieldProps("last_name")}
      />
      {formik.touched.last_name && formik.errors.last_name ? (
        <div className="fv-plugins-message-container">
          <div className="fv-help-block">{formik.errors.last_name}</div>
        </div>
      ) : null}
    </div>
  );
};

export default LastName;